<template>
  <div class="wrapper">
    <h1>{{ heading }}</h1>
    <p>{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    heading: {
      type: String,
    },
    description: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 2rem;
}

h1 {
  color: #202223;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
}

p {
  color: #6d7175;
  font-size: 14px;
  line-height: 20px;
}
</style>
